// extracted by mini-css-extract-plugin
export default {"otpInput":"otp_otpInput__KUdsY"};